import {
  ADD_CANVAS,
  ADD_CANVAS_SUCCESS,
  ADD_CANVAS_FAILED,
  FETCH_CANVAS,
  FETCH_CANVAS_SUCCESS,
  FETCH_CANVAS_FAILED,
  EDIT_CANVAS,
  EDIT_CANVAS_SUCCESS,
  EDIT_CANVAS_FAILED,
  DELETE_CANVAS,
  DELETE_CANVAS_SUCCESS,
  DELETE_CANVAS_FAILED,
} from "../store/types";

const INITIAL_STATE = {
  canvasses: [],
  loading: false,
  error: {
    flag: false,
    msg: null,
  },
};

export const canvasreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_CANVAS:
      return {
        ...state,
        loading: true,
      };
    case ADD_CANVAS_SUCCESS:
      return {
        ...state,
        canvasses: action.payload,
        loading: false,
      };
    case ADD_CANVAS_FAILED:
      return {
        ...state,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    case FETCH_CANVAS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_CANVAS_SUCCESS:
      return {
        ...state,
        canvasses: action.payload,
        loading: false,
      };
    case FETCH_CANVAS_FAILED:
      return {
        ...state,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    case EDIT_CANVAS:
      return {
        ...state,
        loading: true,
      };
    case EDIT_CANVAS_SUCCESS:
      return {
        ...state,
        canvasses: action.payload,
        loading: false,
      };
    case EDIT_CANVAS_FAILED:
      return {
        ...state,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    case DELETE_CANVAS:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CANVAS_SUCCESS:
      return {
        ...state,
        canvasses: action.payload,
        loading: false,
      };
    case DELETE_CANVAS_FAILED:
      return {
        ...state,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    default:
      return state;
  }
};
